import { Route, Routes, useLocation } from 'react-router-dom'
import {
  twoStepAuthenticationPath,
  twoStepCodePath,
  twoStepDownloadPath,
  twoStepScanPath
} from 'components/Routes'
import StepLayout, { Step } from 'components/layout/StepLayout'
import TwoStepCode from './TwoStepCode'
import TwoStepDownload from './TwoStepDownload'
import TwoStepScan from './TwoStepScan'

export interface Props {
  setBackupCodes: (value: string[]) => void
}

export default function EnableAuthenticator({
  setBackupCodes
}: Props): JSX.Element {
  const location = useLocation()
  const normalisePath = (path: string) => path.replace(/\/+$/, '')

  const steps: Step[] = [
    {
      header: 'Download app',
      path: twoStepDownloadPath(),
      step: 1
    },
    {
      header: 'Scan this QR code',
      path: twoStepScanPath(),
      step: 2
    },
    {
      header: 'Enter your code',
      path: twoStepCodePath(),
      step: 3
    }
  ]

  const currentPath = normalisePath(location.pathname)
  const currentStep =
    steps.find(step => normalisePath(step.path) === currentPath) ||
    (currentPath === normalisePath(twoStepAuthenticationPath())
      ? steps[0]
      : undefined) ||
    steps[0]

  return (
    <StepLayout backgroundColor='white' currentStep={currentStep} showBackIcon>
      <Routes>
        <Route index element={<TwoStepDownload />} />
        <Route path='download' element={<TwoStepDownload />} />
        <Route path='scan' element={<TwoStepScan />} />
        <Route
          path='code'
          element={<TwoStepCode setBackupCodes={setBackupCodes} />}
        />
        <Route path='*' element={<TwoStepDownload />} />
      </Routes>
    </StepLayout>
  )
}
